"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const cheminfo_font_1 = require("cheminfo-font");
const get_1 = __importDefault(require("lodash/get"));
const react_2 = require("react");
const im_1 = require("react-icons/im");
const ChartContext_1 = require("../../context/ChartContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const ActiveButton_1 = __importDefault(require("../../elements/ActiveButton"));
const ToolTip_1 = __importDefault(require("../../elements/ToolTip/ToolTip"));
const Modal_1 = require("../../elements/popup/Modal");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const ChangeSumModal_1 = __importDefault(require("../../modal/changeSum/ChangeSumModal"));
const BasicPanelStyle_1 = require("../extra/BasicPanelStyle");
const DefaultPanelHeader_1 = __importStar(require("../header/DefaultPanelHeader"));
const PreferencesHeader_1 = __importDefault(require("../header/PreferencesHeader"));
const IntegralTable_1 = __importDefault(require("./IntegralTable"));
const IntegralsPreferences_1 = __importDefault(require("./IntegralsPreferences"));
const style = (0, react_1.css) `
  .sum-button {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
function IntegralPanelInner({ integrals, info, activeTab, xDomain, }) {
    const [filterIsActive, setFilterIsActive] = (0, react_2.useState)(false);
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const [isFlipped, setFlipStatus] = (0, react_2.useState)(false);
    const settingRef = (0, react_2.useRef)();
    const yesHandler = (0, react_2.useCallback)(() => {
        dispatch({ type: 'DELETE_INTEGRAL', payload: {} });
    }, [dispatch]);
    const handleDeleteAll = (0, react_2.useCallback)(() => {
        modal.showConfirmDialog({
            message: 'All records will be deleted, Are You sure?',
            buttons: [{ text: 'Yes', handler: yesHandler }, { text: 'No' }],
        });
    }, [modal, yesHandler]);
    const changeIntegralSumHandler = (0, react_2.useCallback)((options) => {
        dispatch({ type: 'CHANGE_INTEGRAL_SUM', payload: { options } });
    }, [dispatch]);
    const currentSum = (0, react_2.useMemo)(() => {
        return (0, get_1.default)(integrals, 'options.sum', null);
    }, [integrals]);
    const settingsPanelHandler = (0, react_2.useCallback)(() => {
        setFlipStatus(!isFlipped);
    }, [isFlipped]);
    const saveSettingHandler = (0, react_2.useCallback)(() => {
        settingRef.current.saveSetting();
        setFlipStatus(false);
    }, []);
    const handleOnFilter = (0, react_2.useCallback)(() => {
        setFilterIsActive(!filterIsActive);
    }, [filterIsActive]);
    const toggleConstantSumHandler = (0, react_2.useCallback)(() => {
        dispatch({ type: 'CHANGE_INTEGRALS_SUM_FLAG' });
    }, [dispatch]);
    const filteredData = (0, react_2.useMemo)(() => {
        function isInRange(from, to) {
            const factor = 10000;
            to = to * factor;
            from = from * factor;
            return ((to >= xDomain[0] * factor && from <= xDomain[1] * factor) ||
                (from <= xDomain[0] * factor && to >= xDomain[1] * factor));
        }
        if (info.dimension === 1 && integrals?.values) {
            const _integrals = filterIsActive
                ? integrals.values.filter((integral) => isInRange(integral.from, integral.to))
                : integrals.values;
            return _integrals.map((integral) => {
                return {
                    ...integral,
                    isConstantlyHighlighted: isInRange(integral.from, integral.to),
                };
            });
        }
        return [];
    }, [filterIsActive, info.dimension, integrals, xDomain]);
    const counter = integrals?.values?.length || 0;
    return ((0, jsx_runtime_1.jsxs)("div", { css: [
            BasicPanelStyle_1.tablePanelStyle,
            style,
            isFlipped &&
                (0, react_1.css) `
            th {
              position: relative;
            }
          `,
        ], children: [!isFlipped && ((0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { counter: counter, counterLabel: (0, DefaultPanelHeader_1.createFilterLabel)(counter, filterIsActive && filteredData?.length), onDelete: handleDeleteAll, deleteToolTip: "Delete All Integrals", onFilter: handleOnFilter, filterToolTip: filterIsActive ? 'Show all integrals' : 'Hide integrals out of view', showSettingButton: true, onSettingClick: settingsPanelHandler, children: [(0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: currentSum
                            ? `Change integration sum (${currentSum.toFixed(2)})`
                            : 'Change integration sum', popupPlacement: "right", children: (0, jsx_runtime_1.jsx)(ChangeSumModal_1.default, { onSave: changeIntegralSumHandler, sumType: "integrals", currentSum: currentSum, sumOptions: integrals?.options, renderButton: (onClick) => ((0, jsx_runtime_1.jsx)("button", { className: "sum-button", type: "button", onClick: onClick, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrSum, {}) })) }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { className: "icon", popupTitle: "Fixed integration values", popupPlacement: "right", onClick: toggleConstantSumHandler, value: integrals?.options?.isSumConstant || false, children: (0, jsx_runtime_1.jsx)(im_1.ImLink, {}) })] })), isFlipped && ((0, jsx_runtime_1.jsx)(PreferencesHeader_1.default, { onSave: saveSettingHandler, onClose: settingsPanelHandler })), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", children: !isFlipped ? ((0, jsx_runtime_1.jsx)(IntegralTable_1.default, { data: filteredData, info: info, activeTab: activeTab })) : ((0, jsx_runtime_1.jsx)(IntegralsPreferences_1.default, { ref: settingRef })) })] }));
}
const MemoizedIntegralPanel = (0, react_2.memo)(IntegralPanelInner);
const emptyData = { integrals: {}, info: {} };
function IntegralPanel() {
    const { xDomain, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const { integrals, info } = (0, useSpectrum_1.default)(emptyData);
    return ((0, jsx_runtime_1.jsx)(MemoizedIntegralPanel, { integrals,
        info,
        xDomain,
        activeTab }));
}
exports.default = IntegralPanel;
